import { Dimensions, Weight } from 'models/product';
import { HelmetIcon } from 'i/measurement/helmet-icon';
import { GogglesIcon } from 'i/measurement/goggles-icon';
import { BootsIcon } from 'i/measurement/boot-icon';
import { GearIcon } from 'i/measurement/gear-icon';
const CategoryMeasurementSection = ({
  category,
  onSelect,
  weight,
  dimensions,
}: {
  category: string;
  weight: Weight;
  dimensions: Dimensions;
  onSelect: (measurements: { weight: Weight; dimensions: Dimensions }) => void;
}) => {
  const formatWeight = (weight?: number) => {
    if (!weight) {
      return 0;
    }

    if (weight < 16) {
      return weight + ' oz';
    } else {
      return (weight / 16).toFixed(2) + ' lbs';
    }
  };

  return (
    <>
      <hr />
      <div
        className="flex cursor-pointer items-center gap-[1.8rem] px-[1.4rem] py-[0.8rem] hover:bg-brand-darker-white"
        onClick={() => onSelect({ weight: weight, dimensions: dimensions })}
      >
        <div className="flex w-full items-center justify-between text-end text-[1.6rem]">
          <div className="flex items-center gap-x-4">
            {category.toLowerCase().includes('gear') && (
              <GearIcon className="h-20 w-20" />
            )}

            {category.toLowerCase().includes('helmet') && (
              <HelmetIcon className="h-20 w-20" />
            )}

            {category.toLowerCase().includes('goggles') && (
              <GogglesIcon className="h-20 w-20" />
            )}

            {category.toLowerCase().includes('boots') && (
              <BootsIcon className="h-20 w-20" />
            )}

            <h5 className="font-semibold text-brand-secondary">{category}</h5>
          </div>

          <p className="text-end text-brand-dark-gray">{`${formatWeight(
            weight.value
          )} - ${dimensions.length} x ${dimensions.width} x ${
            dimensions.height
          }`}</p>
        </div>
      </div>
    </>
  );
};

export default CategoryMeasurementSection;
